import axios from './axios';
import utils from '../libs/utils';

const MODULE_NAME = 'v1/erp-base-web';

export default {
  axios,
  /**
   * 商品接口
   * @param params
   * @returns {Q.Promise<any> | AxiosPromise<any>}
   */
  GoodsDictionary(params) {
    return axios.post(`${MODULE_NAME}/goods/dictionary/list`, utils.exchangeParams(params));
  },
  createGoodsLabel(params) {
    return axios.post(`${MODULE_NAME}/goods/label/create`, utils.exchangeParams(params));
  },
  updateGoodsLabel(params) {
    return axios.post(`${MODULE_NAME}/goods/label/update`, utils.exchangeParams(params));
  },
  getGoodsLabelById(params) {
    return axios.get(`${MODULE_NAME}/goods/label/find?${utils.exchangeParams(params)}`);
  },
  listGoodsLabels(params) {
    return axios.get(`${MODULE_NAME}/goods/label/list?${utils.exchangeParams(params)}`);
  },
  enableGoodsLabel(params) {
    return axios.post(`${MODULE_NAME}/goods/label/enable`, utils.exchangeParams(params));
  },
  disableGoodsLabel(params) {
    return axios.post(`${MODULE_NAME}/goods/label/disable`, utils.exchangeParams(params));
  },
  listGoodsBases(params) { // search
    return axios.get(`${MODULE_NAME}/goods/base/list?${utils.exchangeParams(params)}`);
  },
  mergeEqualGoods(params) { // search
    return axios.get(`${MODULE_NAME}/goods/base/list?${utils.exchangeParams(params)}`);
  },
  exportGoodsBases(params) { // export
    return axios.get(`${MODULE_NAME}/goods/base/export?${utils.exchangeParams(params)}`);
  },
  createGoodsBase(params) {
    return axios.post(`${MODULE_NAME}/goods/base/create`, utils.exchangeParams(params));
  },
  updateGoodsBase(params) {
    return axios.post(`${MODULE_NAME}/goods/base/update`, utils.exchangeParams(params));
  },
  getGoodsBaseById(params) {
    return axios.get(`${MODULE_NAME}/goods/base/find?${utils.exchangeParams(params)}`);
  },
  enableGoodsBase(params) {
    return axios.post(`${MODULE_NAME}/goods/base/enable`, utils.exchangeParams(params));
  },
  disableGoodsBase(params) {
    return axios.post(`${MODULE_NAME}/goods/base/disable`, utils.exchangeParams(params));
  },
  existsGoodsBase(params) {
    return axios.get(`${MODULE_NAME}/goods/base/exists?${utils.exchangeParams(params)}`);
  },
  submitGoodsStore(params) {
    return axios.post(`${MODULE_NAME}/goods/store/submit`, utils.exchangeParams(params));
  },
  insertGoodsStore(params) {
    return axios.post(`${MODULE_NAME}/goods/store/insert`, utils.exchangeParams(params));
  },
  updateGoodsStore(params) {
    return axios.post(`${MODULE_NAME}/goods/store/update`, utils.exchangeParams(params));
  },
  getGoodsStoreById(params) {
    return axios.get(`${MODULE_NAME}/goods/store/find?${utils.exchangeParams(params)}`);
  },
  listGoodsStores(params) { // search
    return axios.get(`${MODULE_NAME}/goods/store/list?${utils.exchangeParams(params)}`);
  },
  exportGoodsStores(params) { // search
    return axios.get(`${MODULE_NAME}/goods/store/export?${utils.exchangeParams(params)}`);
  },
  listGoodsStoresPassed(params) {
    return axios.get(`${MODULE_NAME}/goods/store/pass/list/byIds?${utils.exchangeParams(params)}`);
  },
  listIndications() {
    return axios.get(`${MODULE_NAME}/goods/label/indication/list`);
  },
  listGoodsLabelCategories() {
    return axios.get(`${MODULE_NAME}/goods/label/category/list`);
  },
  getGoodsStoreSupplierList(params) {
    return axios.get(`${MODULE_NAME}/goods/store/supplier/list?${utils.exchangeParams(params)}`);
  },
  enableGoodsStoreById(params) {
    return axios.post(`${MODULE_NAME}/goods/store/enable`, utils.exchangeParams(params));
  },
  disableGoodsStoreById(params) {
    return axios.post(`${MODULE_NAME}/goods/store/disable`, utils.exchangeParams(params));
  },
  getSupplierInfoById(params) {
    return axios.get(`${MODULE_NAME}/goods/store/supplier/find?${utils.exchangeParams(params)}`);
  },
  getAllDictionary(params) {
    return axios.post(`${MODULE_NAME}/goods/dictionary/list`, utils.exchangeParams(params));
  },
  getStoreRecord(params) {
    return axios.post(`${MODULE_NAME}/goods/history/list/store`, utils.exchangeParams(params));
  },
  getBaseRecord(params) {
    return axios.post(`${MODULE_NAME}/goods/history/list/base`, utils.exchangeParams(params));
  },
  storeCheckIsExist(params) {
    return axios.get(`${MODULE_NAME}/goods/store/get?${utils.exchangeParams(params)}`);
    // return axios.get(`${MODULE_NAME}/goods/store/get?${utils.exchangeParams(params)}`);
  },
  baseCheckIsExist(params) {
    return axios.get(`${MODULE_NAME}/goods/base/get?${utils.exchangeParams(params)}`);
    // return axios.get(`${MODULE_NAME}/goods/base/get?${utils.exchangeParams(params)}`);
  },
  getGoodsLabelDropList(params) {
    return axios.get(`${MODULE_NAME}/goods/label/dropList?${utils.exchangeParams(params)}`);
    // return axios.get(`${MODULE_NAME}/goods/base/get?${utils.exchangeParams(params)}`);
  },
  getGoodsStorePrintInfo(params) {
    return axios.get(`${MODULE_NAME}/goods/store/print?${utils.exchangeParams(params)}`);
  },
  getDrugInstruction(params) {
    return axios.get(`${MODULE_NAME}/goods/base/getInstruction?${utils.exchangeParams(params)}`);
  },
  getDoctorList(params) {
    return axios.get(`v1/erp-business-web/electronic/prescription/internet/doctor/query?${utils.exchangeParams(params)}`)
  },
  getElectronicInfoByCode(params) { //获取关联处方
    return axios.get(`/v1/erp-business-web/electronic/prescription/getElectronicInfoByCode?${utils.exchangeParams(params)}`);
  },
  getPurchaseRecord(params) { //处方输入患者姓名和手机号后加载历史购药记录
    return axios.get(`/v1/erp-business-web/electronic/prescription/initPurchaseRecord?${utils.exchangeParams(params)}`);
  },
  addOrEditPrescription(params) { //新增，编辑处方笺
    return axios.post(`/v1/erp-business-web/electronic/prescription/addOrEdit`, params);
  },
  approvalPrescription(params) { //审核通过处方笺
    return axios.post(`/v1/erp-base-web/pharmacy/review/approval`, params);
  },
  deleteListData(params) { // 删除
    return axios.post('/v1/erp-base-web/goods/store/delete', utils.exchangeParams(params));
  },
};
